import type { AdminApi } from '@remote-medium/api/rpc';
import { hc } from 'hono/client';

export const API_ORIGIN: string =
  (import.meta.env['VITE_API_ORIGIN'] as string | undefined) ?? 'http://localhost:8787';

export const admin = hc<AdminApi>(`${API_ORIGIN}/admin`, { init: { credentials: 'include' } });
